// Dependencies
import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";

import {
  BackImage,
  BookingFormView,
  CheckLogin,
  CollectionView,
  ContactView,
  DirectoryView,
  ExhibitionView,
  FastFactsView,
  FavoriteView,
  Header,
  HomeView,
  MessageCenter,
  MobileWarning,
  NotFoundView,
  NotLoggedInView,
  RewardsView,
  RetainContentView,
  RetainView,
  Search,
  ShowcaseCollectionView,
  ShowcaseCollectionCountryView,
  SubAppView,
  ThankYouView,
  ToolboxView,
  TermsView,
  TrainingContentView,
  TrainingView,
  WebsiteSplitter,
} from "C4";

const loginPages = ["training", "retain"];
const paths = `(${loginPages.join("|")})`;

const SubRouter = () => (
  <div className="subRouter" id="container">
    <Route path={`/main/${paths}`} render={() => <CheckLogin />} />
    <Route
      path="/main/"
      render={(routerProps) => {
        const { pathname } = routerProps.location;
        if (pathname.includes("main/training/chapter/")) {
          return null;
        }
        if (pathname.includes("main/fasttrack/chapter/")) {
          return null;
        }
        if (pathname.includes("main/directory")) {
          return null;
        }
        if (pathname.includes("main/sell/directory")) {
          return null;
        }
        return <Header pathname={pathname} />;
      }}
    />
    <div className="viewContainer">
      <BackImage key={window.location.pathname} />
      <Switch>
        <Route path="/main" exact component={HomeView} />
        <Route
          path="/main/ret/chapter"
          exact
          render={() => <Redirect to="/main/ret" />}
        />
        <Route path="/main/retain" exact component={RetainView} />
        <Route
          path="/main/ret/chapter/:chapterId/:pageId"
          exact
          component={RetainContentView}
        />
        <Route
          path="/main/:pageType/chapter/:chapterId/:pageId"
          render={(props) => {
            const { pageType, pageId } = props.match.params;
            switch (pageType) {
              case "ret":
                return <RetainContentView key={pageId} {...props} />;
              case "training":
              case "fasttrack":
                return (
                  <TrainingContentView
                    key={pageId}
                    redirPath={`/main/${pageType}/chapter/`}
                    type={pageType}
                    {...props}
                  />
                );
              default:
                return null;
            }
          }}
        />
        <Route path="/main/off" component={NotLoggedInView} />
        <Route component={NotFoundView} />
      </Switch>
    </div>
    {/* <Footer /> */}
  </div>
);

export default withRouter(SubRouter);
